import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NavigationModule } from '../../shared/navigation/navigation.module'
import { TopHeaderComponent } from './header/header.component';
import { SpinnerComponent } from './spinner/spinner.component';

@NgModule({
	declarations: [
		TopHeaderComponent
		, SpinnerComponent
	]
    , imports: [
		CommonModule
		, RouterModule
        , NavigationModule
	]
    , exports: [
		TopHeaderComponent
		, SpinnerComponent
        , NavigationModule
	]
})
export class LayoutModule {}
